var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Linkdine"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Linkdine",
    clipPath: "url(#clip-Linkdine)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10836",
    "data-name": "Group 10836",
    transform: "translate(1 1.411)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    transform: "translate(0 -0.411)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    strokeDasharray: "0 0"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Linkedin",
    transform: "translate(5.71 5.937)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11590",
    "data-name": "Path 11590",
    d: "M123.679,756.609h1.89v6.077h-1.89Zm.946-3.019a1.1,1.1,0,1,1-1.1,1.1,1.1,1.1,0,0,1,1.1-1.1",
    transform: "translate(-123.53 -753.59)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11591",
    "data-name": "Path 11591",
    d: "M140.37,768.723h1.809v.831h.034a1.983,1.983,0,0,1,1.786-.98c1.915,0,2.265,1.258,2.265,2.893V774.8h-1.888v-2.954c0-.7-.011-1.612-.98-1.612s-1.133.766-1.133,1.56V774.8h-1.886Z",
    transform: "translate(-137.146 -765.704)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.2a202ac608af323657c63cd5a13502ee.svg";
export { ForwardRef as ReactComponent };